import React from "react";
import Loadable from "react-loadable";
import { Switch, Route } from "react-router-dom";
import {NotFound} from "~/views/Errors";
import LoadingSpinner from "~/components/LoadingSpinner";

const FinancialNotesView = Loadable({
    loader: () => import("~/views/admin/notes/FinancialNotesView"),
    loading: LoadingSpinner
});

export default ({ match }) => (
    <Switch>
        <Route path={`${match.url}/`} component={FinancialNotesView} />
        <Route component={NotFound} />
    </Switch>
);